import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ArtistQuoteDashboard from "../components/ArtistQuoteDashboard";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function ArtistQuotePage() {
  const { t } = useTranslation();
  const [artistName, setArtistName] = useState("");
  const [medium, setMedium] = useState("huile");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <h1 className="text-3xl font-bold mb-4">{t("artistQuotePage.title")}</h1>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1 font-medium">{t("artistQuotePage.artistName")}</label>
          <Input
            type="text"
            value={artistName}
            onChange={(e) => setArtistName(e.target.value)}
            placeholder={t("artistQuotePage.artistPlaceholder")}
            required
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">{t("artistQuotePage.medium")}</label>
          <select value={medium} onChange={(e) => setMedium(e.target.value)} className="form-control-artsy">
            <option value="huile">{t("artistQuotePage.mediums.oil")}</option>
            <option value="aquarelle">{t("artistQuotePage.mediums.watercolor")}</option>
            <option value="dessin">{t("artistQuotePage.mediums.drawing")}</option>
            <option value="sculpture">{t("artistQuotePage.mediums.sculpture")}</option>
          </select>
        </div>

        <Button type="submit" className="btn-artsy">{t("artistQuotePage.submit")}</Button>
      </form>

      {submitted && artistName && <ArtistQuoteDashboard artistName={artistName} medium={medium} />}
    </div>
  );
}
